import Vue from 'vue'
import router from './router'
import * as Sentry from '@sentry/vue'

const defaultIntegrations = Sentry.getDefaultIntegrations({})
  .filter(integration => !['GlobalHandlers', 'TryCatch'].includes(integration.name))

function getSentryEnvironment() {
  const host = window.location.host;
  const apiRoot = process.env.VUE_APP_API_ROOT || '';
  const nodeEnv = process.env.NODE_ENV || 'unknown';

  if (host.includes('localhost') || host.includes('127.0.0.1')) {
    return apiRoot.includes('api.ai-tax.cn') ? 'local-production' : 'local'
  }
  if (apiRoot.includes('api.ai-tax.cn')) return 'production'
  if (apiRoot.includes('test.ai-tax.cn')) return 'test'
  if (apiRoot.includes('dev.ai-tax.cn')) return 'development'

  return nodeEnv
}

// 初始化Sentry
Sentry.init({
  Vue,
  dsn: 'https://7de044415996a5c878a90050eb7335be@sentry.ai-tax.cn/2',
  release: process.env.VUE_APP_SENTRY_RELEASE,
  environment: getSentryEnvironment(),
  defaultIntegrations,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      maskAllText: false
    })
  ],
  tracesSampleRate: 1.0, // 采样率，生产环境可适当降低
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    // 可添加需要忽略的错误类型
    // 'Network Error',
    // 'Script error.'
  ]
})

// 导出Sentry实例供其他地方使用
export default Sentry  
